var createSvgElement, i, len, lookup, name, svgTags;

createSvgElement = function(name) {
  var el;
  el = document.createElementNS("http://www.w3.org/2000/svg", name);
  if (name === "svg") {
    el.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
  }
  return el;
};

svgTags = ["svg", "animate", "circle", "clippath", "cursor", "defs", "desc", "ellipse", "filter", "fontFace", "foreignObject", "g", "glyph", "image", "line", "marker", "mask", "missingGlyph", "path", "pattern", "polygon", "polyline", "rect", "switch", "symbol", "text", "textpath", "tspan", "use", "view"];

lookup = {};

for (i = 0, len = svgTags.length; i < len; i++) {
  name = svgTags[i];
  lookup[name] = createSvgElement;
}

module.exports = {
  _name: "svg",
  _v: 1,
  _elLookup: lookup,
  mixins: [require("./structure")]
};

;



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/svg.js
// module id = 43
// module chunks = 1